import { render, staticRenderFns } from "./TopicReviewDetail.vue?vue&type=template&id=6fbc8836&scoped=true&"
import script from "./TopicReviewDetail.vue?vue&type=script&lang=js&"
export * from "./TopicReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./TopicReviewDetail.vue?vue&type=style&index=0&id=6fbc8836&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc8836",
  null
  
)

export default component.exports